import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  delete_Record,
  errorMessage,
} from "../CommonFunctions";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";
import swal from "sweetalert";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  POST_GetMachineCalibrationList,
  POST_MachineCalibrationActiveInActive,
  POST_MachineCalibrationDelete,
  POST_MachineCalibrationExport,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const MachinesCalibration = () => {
  const [showFilter, setShowFilter] = useState(false);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  // const [currentPage, setCurrentPage] = useState(1);
  // const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  // const [recordCount, setRecordCount] = useState(0);
  // const [sortBy, setSortBy] = useState("");
  // const [orderBy, setOrderBy] = useState("asc");

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "machines-calibration" ? filter?.CurrentPage : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "machines-calibration" ? filter?.PageSize : 10,
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "machines-calibration" ? filter?.sortBy : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "machines-calibration" ? filter?.orderBy : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  const [machinesCalibrationList, setMachinesCalibrationList] = useState([]);

  const [listOfMachineCalibrationDocuments, setMachineCalibrationDocuments] =
    useState([]);

  const [
    showMachineCalibrationDocumentsModal,
    setShowMachineCalibrationDocumentsModal,
  ] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Status:
        filter && filter?.page == "machines-calibration" ? filter?.Status : -1,
      Search:
        filter && filter?.page == "machines-calibration" ? filter?.Search : "",
      // Search: "",
      // Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, Status },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: -1,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "machines-calibration",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };
    await post(POST_GetMachineCalibrationList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setMachinesCalibrationList(response?.MachineCalibrationList);
        setIsLoading(false);
        if (page > 1 && response?.MachineCalibrationList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    // setMachinesCalibrationList([
    //   {
    //     MachineCalibrationIDEncrypt: "lrQ+Ao+IEjI=",
    //     MachineName: "Machine-35",
    //     MaintenanceDate: "22/Jan/2024",
    //     CalibrationDate: "22/Jan/2024",
    //     CalibrationValidity: "5",
    //     MaintanceBy: "Kamal Thakur",
    //     Description: "njh jkhg lkd",
    //     Agency: "er",
    //     PreventiveAction: "dfg ",
    //     Remarks: "df",
    //     IsActive: true,
    //     ListOfMachineCalibrationDocuments: [
    //       {
    //         MachineCalibrationDocumentsIDEncrypted: "",
    //         MachineCalibrationIDEncrypted: "",
    //         DocumentsType: 1,
    //         MachineCalibrationDocumentFile: "ad",
    //         MachineCalibrationDocumentFileName: "jdjh gsdjh",
    //         MachineCalibrationDocumentPath: "sdf",
    //         IsDeleted: false,
    //       },
    //       {
    //         MachineCalibrationDocumentsIDEncrypted: "",
    //         MachineCalibrationIDEncrypted: "",
    //         DocumentsType: 2,
    //         MachineCalibrationDocumentFile: "ad dfd",
    //         MachineCalibrationDocumentFileName: "jdjh 55655",
    //         MachineCalibrationDocumentPath: "sdf df",
    //         IsDeleted: false,
    //       },
    //     ],
    //   },
    //   {
    //     MachineCalibrationIDEncrypt: "rXLJQ7soUaw=",
    //     MachineName: "Q4 TASMAN Spectrometer",
    //     MaintenanceDate: "28/Jan/2024",
    //     CalibrationDate: "29/Jan/2024",
    //     CalibrationValidity: "35",
    //     MaintanceBy: "Kamal Thakur",
    //     Description: "njh jkhg lkd",
    //     Agency: "er",
    //     PreventiveAction: "dfg ",
    //     Remarks: "df",
    //     IsActive: true,
    //     ListOfMachineCalibrationDocuments: [],
    //   },
    // ]);
  };

  const viewMachineCalibrationDocuments = (list) => {
    setMachineCalibrationDocuments([]);
    setShowMachineCalibrationDocumentsModal(true);
    setMachineCalibrationDocuments(list);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };
    post(POST_MachineCalibrationExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Machines Calibration</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 26 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    // className="btn btn-primary light btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 26 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="/add-machines-calibration"
                    // className="btn btn-primary btn-sm"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa-solid fa-plus"></i> Add Machines
                    Calibration
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Status"
                            name="Status"
                            placeholder={"Select Status"}
                            options={statusOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>

                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                // className="btn btn-primary btn-sm mb-1"
                                className="btn btn-primary btn-sm mb-1"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>
                                {"  "} Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="MachinesCalibration-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="MachinesCalibration-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="6%"></th>
                      <th
                        style={{
                          width: "20%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("MachineName");
                        }}
                      >
                        Machines{" "}
                        <span className="ml-1">
                          {sortBy == "MachineName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "12%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("MachineNumber");
                        }}
                      >
                        Machine Number{" "}
                        <span className="ml-1">
                          {sortBy == "MachineNumber" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "12%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("MaintenanceDate");
                        }}
                      >
                        Maintenance Date{" "}
                        <span className="ml-1">
                          {sortBy == "MaintenanceDate" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "10%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("CalibrationDate");
                        }}
                      >
                        Calibration Date{" "}
                        <span className="ml-1">
                          {sortBy == "CalibrationDate" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "8%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("CalibrationValidity");
                        }}
                      >
                        Validity{" "}
                        <span className="ml-1">
                          {sortBy == "CalibrationValidity" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "14%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("MaintanceBy");
                        }}
                      >
                        Maintance By{" "}
                        <span className="ml-1">
                          {sortBy == "MaintanceBy" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      {/* <th
                        style={{
                          width: "12%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("Description");
                        }}
                      >
                        Description{" "}
                        <span className="ml-1">
                          {sortBy == "Description" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th> */}
                      <th
                        style={{
                          width: "18%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("Agency");
                        }}
                      >
                        Agency{" "}
                        <span className="ml-1">
                          {sortBy == "Agency" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      {/* <th
                        style={{
                          width: "15%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("PreventiveAction");
                        }}
                      >
                        Preventive Action{" "}
                        <span className="ml-1">
                          {sortBy == "PreventiveAction" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th> */}
                      {/* <th
                        style={{
                          width: "12%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("Remarks");
                        }}
                      >
                        Remarks{" "}
                        <span className="ml-1">
                          {sortBy == "Remarks" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {machinesCalibrationList?.length > 0 ? (
                      machinesCalibrationList?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 26 && x?.IsEdit,
                            )?.length > 0 ? (
                              <Link
                                to={`/edit-machines-calibration/${window.btoa(
                                  item.MachineCalibrationIDEncrypt,
                                )}`}
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 26 && x?.IsActive,
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className={`icon-box icon-box-md bg-${
                                //   item.IsActive == true ? "success" : "danger"
                                // }-light me-1`}
                                className={`icon-box icon-box-md me-1`}
                                title={
                                  item.IsActive == true ? "Active" : "Inactive"
                                }
                                onClick={() => {
                                  ActiveInactive_Record(
                                    item.IsActive,
                                    POST_MachineCalibrationActiveInActive,
                                    {
                                      MachineCalibrationIDEncrypt:
                                        item.MachineCalibrationIDEncrypt,
                                      IsActive: !item.IsActive,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.MachineName,
                                  );
                                }}
                              >
                                <i
                                  className={`fa fa-circle fs-15 ${
                                    item.IsActive == true
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                ></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 26 && x?.IsDelete,
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-danger-light"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                onClick={() => {
                                  delete_Record(
                                    POST_MachineCalibrationDelete,
                                    {
                                      MachineCalibrationIDEncrypt:
                                        item.MachineCalibrationIDEncrypt,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.MachineName,
                                  );
                                }}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                            ) : (
                              ""
                            )}
                            {item?.ListOfMachineCalibrationDocuments?.length >
                            0 ? (
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Download Documents"
                                onClick={() => {
                                  viewMachineCalibrationDocuments(
                                    item?.ListOfMachineCalibrationDocuments,
                                  );
                                }}
                              >
                                {SVGICON.Download}
                              </Link>
                            ) : (
                              ""
                            )}
                          </td>
                          <td> {item?.MachineName}</td>
                          <td> {item?.MachineNumber}</td>
                          <td> {item?.MaintenanceDate}</td>
                          <td> {item?.CalibrationDate}</td>
                          <td> {item?.CalibrationValidity}</td>
                          {/* <td> {item?.MaintanceBy}</td> */}
                          <td
                            style={{
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            className="popupOverlay"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.MaintanceBy}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.MaintanceBy}</span>
                            </OverlayTrigger>
                          </td>
                          {/* <td> {item?.Description}</td> */}
                          {/* <td> {item?.Agency}</td> */}
                          <td
                            style={{
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            className="popupOverlay"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">{item.Agency}</strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.Agency}</span>
                            </OverlayTrigger>
                          </td>
                          {/* <td
                            style={{
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            className="popupOverlay"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.PreventiveAction}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.PreventiveAction}</span>
                            </OverlayTrigger>
                          </td> */}
                          {/* <td style={{ textAlign: "left" }}>
                            {item?.PreventiveAction}
                          </td> */}
                          {/* <td style={{ textAlign: "left" }}>{item.Remarks}</td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showMachineCalibrationDocumentsModal}
          onHide={setShowMachineCalibrationDocumentsModal}
          size="lg"
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Machine Calibration Documents</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMachineCalibrationDocumentsModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting">
                    <div
                      id="MachineCalibrationDocuments-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="MachineCalibrationDocuments-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="2%"></th>
                            <th width="28%">Documents Type</th>
                            <th width="70%" style={{ textAlign: "left" }}>
                              Documents Preview
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {listOfMachineCalibrationDocuments?.length > 0 ? (
                            listOfMachineCalibrationDocuments?.map(
                              (item, indx) => (
                                <tr>
                                  <td>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item?.MachineCalibrationDocumentPath
                                            ? item?.MachineCalibrationDocumentPath
                                            : "",
                                          "_blank",
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Link>
                                  </td>
                                  <td>
                                    {item?.DocumentsType == 1
                                      ? "Certificate"
                                      : "Additional Documents"}
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    {item?.MachineCalibrationDocumentFileName}
                                  </td>
                                </tr>
                              ),
                            )
                          ) : (
                            <tr>
                              <td colSpan={3} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowMachineCalibrationDocumentsModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default MachinesCalibration;
